import LoadMap from "./LoadMap";

export default LoadMap;